"use client";
import { useRouter } from "next/navigation";
import React from "react";

const SearchProfil = () => {
  const router = useRouter();
  function search(formData) {
    const query = formData.get("search");
    router.push(`/profil?search=${query}`);
  }

  return (
    <form action={search}>
      <input
        type="text"
        name="search"
        className="w-full px-3 py-1.5 rounded-md ring-1 ring-gray-200 focus:outline focus:outline-2 focus:outline-gray-200"
        placeholder="Cari yang berkenaan dengan pondok pesantren"
      />
    </form>
  );
};

export default SearchProfil;
